import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=70677ad3"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=70677ad3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports